/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../../common";
import type {
  AggregateCall,
  AggregateCallInterface,
} from "../../../../contracts/dependant/util/AggregateCall";

const _abi = [
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "target",
            type: "address",
          },
          {
            internalType: "bytes",
            name: "callData",
            type: "bytes",
          },
        ],
        internalType: "struct AggregateCall.Call[]",
        name: "calls",
        type: "tuple[]",
      },
    ],
    name: "aggregate",
    outputs: [
      {
        internalType: "uint256",
        name: "blockNumber",
        type: "uint256",
      },
      {
        internalType: "bytes[]",
        name: "returnData",
        type: "bytes[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "target",
            type: "address",
          },
          {
            internalType: "bytes",
            name: "callData",
            type: "bytes",
          },
        ],
        internalType: "struct AggregateCall.Call[]",
        name: "calls",
        type: "tuple[]",
      },
    ],
    name: "aggregateDetail",
    outputs: [
      {
        internalType: "uint256",
        name: "blockNumber",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "bool",
            name: "success",
            type: "bool",
          },
          {
            internalType: "bytes",
            name: "returnData",
            type: "bytes",
          },
        ],
        internalType: "struct AggregateCall.Return[]",
        name: "returnData",
        type: "tuple[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "target",
            type: "address",
          },
          {
            internalType: "bytes",
            name: "callData",
            type: "bytes",
          },
        ],
        internalType: "struct AggregateCall.Call[]",
        name: "calls",
        type: "tuple[]",
      },
    ],
    name: "aggregateStatic",
    outputs: [
      {
        internalType: "uint256",
        name: "blockNumber",
        type: "uint256",
      },
      {
        internalType: "bytes[]",
        name: "returnData",
        type: "bytes[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "target",
            type: "address",
          },
          {
            internalType: "bytes",
            name: "callData",
            type: "bytes",
          },
        ],
        internalType: "struct AggregateCall.Call[]",
        name: "calls",
        type: "tuple[]",
      },
    ],
    name: "aggregateStaticDetail",
    outputs: [
      {
        internalType: "uint256",
        name: "blockNumber",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "bool",
            name: "success",
            type: "bool",
          },
          {
            internalType: "bytes",
            name: "returnData",
            type: "bytes",
          },
        ],
        internalType: "struct AggregateCall.Return[]",
        name: "returnData",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "blockNumber",
        type: "uint256",
      },
    ],
    name: "getBlockHash",
    outputs: [
      {
        internalType: "bytes32",
        name: "blockHash",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getCurrentBlockCoinbase",
    outputs: [
      {
        internalType: "address",
        name: "coinbase",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getCurrentBlockDifficulty",
    outputs: [
      {
        internalType: "uint256",
        name: "difficulty",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getCurrentBlockGasLimit",
    outputs: [
      {
        internalType: "uint256",
        name: "gaslimit",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getCurrentBlockTimestamp",
    outputs: [
      {
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
    ],
    name: "getEthBalance",
    outputs: [
      {
        internalType: "uint256",
        name: "balance",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getLastBlockHash",
    outputs: [
      {
        internalType: "bytes32",
        name: "blockHash",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type AggregateCallConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: AggregateCallConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class AggregateCall__factory extends ContractFactory {
  constructor(...args: AggregateCallConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<AggregateCall> {
    return super.deploy(overrides || {}) as Promise<AggregateCall>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): AggregateCall {
    return super.attach(address) as AggregateCall;
  }
  override connect(signer: Signer): AggregateCall__factory {
    return super.connect(signer) as AggregateCall__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): AggregateCallInterface {
    return new utils.Interface(_abi) as AggregateCallInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): AggregateCall {
    return new Contract(address, _abi, signerOrProvider) as AggregateCall;
  }
}
